import {
  List,
  SelectBox,
  CheckBox,
  Template,
  DropDownBox,
} from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment from "moment";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { DateFormat } from "../../helpers/fixcodes";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { RegEx } from "../../helpers/fixcodes";
import { useHistory } from "react-router-dom";
import { stashGridState, popGridState } from "../../helpers/gridStateCache";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import DataSource from "devextreme/data/data_source.js";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
} from "../../helpers/message";
import WaitTillMillisecond from "../../helpers/wait";
import { SetPageTitle } from "../../helpers/appsession";
const DutyTypeLst = [
  { id: 0, name: "All Duty" },
  { id: 1, name: "Fly" },
  { id: 2, name: "Non Fly" },
];
const TimeSlotList = [
  { id: 0, name: "All Time" },
  { id: 1, name: "00:00 - 06:00" },
  { id: 2, name: "06:00 - 12:00" },
  { id: 3, name: "12:00 - 18:00" },
  { id: 4, name: "18:00 - 23:59" },
];
const DATE_RANGE_PRESETS = [
  { label: "Today", getRange: () => [moment(), moment()] },
  {
    label: "Yesterday",
    getRange: () => [moment().subtract(1, "day"), moment().subtract(1, "day")],
  },
  {
    label: "This Week",
    getRange: () => [moment().startOf("week"), moment().endOf("week")],
  },
  {
    label: "Last Week",
    getRange: () => [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "This Month",
    getRange: () => [moment().startOf("month"), moment().endOf("month")],
  },
  {
    label: "Last Month",
    getRange: () => [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
];

export default function CrewActivityComponent() {
  const history = useHistory();
  const [state, setState] = useState({
    isFilterSubmitted: false,
    isActivityApiLoading: false,
    isSubmitted: false,
    filterDropdownEmployeeDataSource: [],
    filterEmployeeNumber: "",
    filterDropdownAirportDataSource: [],
    filterAirportCode: "",
    filterDropdownHotelDataSource: [],
    filterHotelId: 0,
    filterHotelApiLoading: true,
    filterFromDatetime: new Date(moment().startOf("day")),
    filterToDatetime: new Date(moment().endOf("day")),
    crewActivityLst: [],
    crewActivityGridDataSource: [],
    openChangeStayLocationPopup: false,
    activityData: null,
    dutyTypeId: 2,
    timeSlotId: 0,
    hotelFilter: "all",
    openChangeHotelPopup: false,
    isToolbarRefreshing: false,
  });
  const refDataGrid = useRef();
  const refDropDownOperator = useRef(null);
  const refLstEmployees = useRef(null);
  const refDateRangePicker = useRef(null);
  const applyDateRangePreset = (preset) => {
    try {
      const [start, end] = preset.getRange();
      setState((prev) => ({
        ...prev,
        filterFromDatetime: start.toDate(),
        filterToDatetime: end.toDate(),
      }));
      if (refDateRangePicker.current) {
        refDateRangePicker.current.setOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const isDateRangePresetActive = (preset) => {
    const [start, end] = preset.getRange();
    return (
      state.filterFromDatetime &&
      state.filterToDatetime &&
      start.isSame(state.filterFromDatetime, "day") &&
      end.isSame(state.filterToDatetime, "day")
    );
  };
  const renderDateRangeCalendarContainer = ({ className, children }) => {
    return (
      <CalendarContainer className={className}>
        <div className="ca-daterange-shell">
          <div className="ca-daterange-presets">
            {DATE_RANGE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`ca-preset-btn${
                  isDateRangePresetActive(preset) ? " active" : ""
                }`}
                onClick={() => applyDateRangePreset(preset)}
              >
                {preset.label}
              </button>
            ))}
          </div>
          <div className="ca-daterange-months">{children}</div>
        </div>
      </CalendarContainer>
    );
  };
  useLayoutEffect(() => {
    SetPageTitle("Crew Activity");
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      // Returning from crew-activity-mobile's Back button stashes this grid's own
      // previous state in an in-memory cache (not router state — too big for
      // history.pushState) — restore it directly instead of refetching everything.
      const cachedState = popGridState();
      if (cachedState) {
        setState((prev) => ({ ...prev, ...cachedState }));
      } else {
        fetchApiOnLoad();
      }
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setState((prev) => ({ ...prev, isActivityApiLoading: true }));
      await Promise.all([
        GetfilterDropdownAirport(),
        GetfilterDropdownEmployee(),
        GetFilterDropdownHotel(""),
        getCrewActivities(),
      ]);
      setState((prev) => ({ ...prev, isActivityApiLoading: false }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownAirport = async () => {
    try {
      const res = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownEmployee = async () => {
    try {
      const res = await axiosGet(`/Crew/get-crew-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      setState((prev) => ({
        ...prev,
        filterDropdownEmployeeDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetFilterDropdownHotel = async (airportCode) => {
    try {
      setState((prev) => ({
        ...prev,
        filterHotelApiLoading: true,
      }));
      const response = await axiosGet(`/Hotel/get-hotel-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
        AirportCode: airportCode,
      });
      setState((prev) => ({
        ...prev,
        filterDropdownHotelDataSource: response?.payload ?? [],
        filterHotelApiLoading: false,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        filterHotelApiLoading: false,
      }));
    }
  };
  const handleOnFilterGridDataSource = async () => {
    try {
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: true,
        isActivityApiLoading: true,
      }));
      await getCrewActivities();
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: false,
        isActivityApiLoading: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewActivities = async () => {
    try {
      if (refDataGrid.current?.instance)
        refDataGrid.current.instance.beginCustomLoading();
      var request = {};
      let filterFromDatetime = moment(state.filterFromDatetime).startOf("day");
      // Range picker leaves the end date null until the second click —
      // fall back to a single-day range in that case
      let filterToDatetime = moment(
        state.filterToDatetime ?? state.filterFromDatetime,
      ).endOf("day");
      request.AirlineCode = sessionStorage.getItem("session_airlineCode");
      request.EmployeeNumber = state.filterEmployeeNumber;
      request.AirportCode = state.filterAirportCode;
      request.HotelId = state.filterHotelId;
      request.ActivateStartDate =
        moment(filterFromDatetime).format(`YYYY-MM-DD HH:mm:ss`);
      request.ActivateEndDate =
        moment(filterToDatetime).format(`YYYY-MM-DD HH:mm:ss`);
      setState((prev) => ({
        ...prev,
        filterFromDatetime: filterFromDatetime,
        filterToDatetime: filterToDatetime,
      }));
      let res = await axiosPost("CrewActivity/schedule-list", request);
      let crewActivityLst = (res?.payload ?? []).sort((a, b) => {
        if (!a.pickupTime) return 1;
        if (!b.pickupTime) return -1;
        return new Date(a.pickupTime) - new Date(b.pickupTime);
      });
      setState((prev) => ({
        ...prev,
        crewActivityLst: crewActivityLst,
      }));
      filterActivityDataGridDutyTypeWise(
        state.dutyTypeId,
        state.timeSlotId,
        crewActivityLst,
        state.hotelFilter,
      );
      if (refDataGrid.current?.instance)
        refDataGrid.current.instance.endCustomLoading();
    } catch (error) {
      console.log(error);
      if (refDataGrid.current?.instance)
        refDataGrid.current.instance.endCustomLoading();
    }
  };
  const handleToolbarRefresh = async () => {
    try {
      setState((prev) => ({ ...prev, isToolbarRefreshing: true }));
      await getCrewActivities();
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isToolbarRefreshing: false }));
    }
  };
  const filterActivityDataGridDutyTypeWise = (
    dutyTypeId,
    timeSlotId,
    crewActivityLst,
    hotelFilter,
  ) => {
    try {
      const crewActivityGridDataSource =
        crewActivityLst?.filter((f) => {
          const dutyMatch =
            dutyTypeId === 0 ||
            (dutyTypeId === 1 &&
              (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
            (dutyTypeId === 2 && f.activityTypeId === 2);

          let timeMatch = true;
          if (timeSlotId > 0 && f.pickupTime) {
            const d = new Date(f.pickupTime);
            const mins = d.getHours() * 60 + d.getMinutes();
            if (timeSlotId === 1) timeMatch = mins < 360;
            else if (timeSlotId === 2) timeMatch = mins >= 360 && mins < 720;
            else if (timeSlotId === 3) timeMatch = mins >= 720 && mins < 1080;
            else if (timeSlotId === 4) timeMatch = mins >= 1080;
          }

          const hotelMatch =
            hotelFilter === "changeHotel"
              ? f.allowAllocateHotel === true
              : true;

          return dutyMatch && timeMatch && hotelMatch;
        }) ?? [];
      setState((prev) => ({
        ...prev,
        crewActivityGridDataSource: crewActivityGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const cellRender = (data) => {
    let tripTypeId = data?.data?.tripTypeId || 0;
    let isHotelDropOff =
      tripTypeId === 2 || tripTypeId === 10 || tripTypeId === 16;
    let cancelHotelStayLinkTitle = `Cancel ${isHotelDropOff ? "Drop-off" : "Pick-up"} Location`;
    let changeHotelLink = data?.data?.allowAllocateHotel && (
      <a
        href="#"
        //className="btn-link"
        title={"Change Hotel"}
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            openChangeHotelPopup: true,
            activityData: data?.data,
          }));
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: "0px",
          }}
          className="fas fa-hotel fa-sm"
        />
      </a>
    );
    let changeAddressStayLink = 1 === 0 && data?.data?.allowChangeAddress && (
      <a
        href="#"
        //className="btn-link"
        title={cancelHotelStayLinkTitle}
        onClick={(e) => {
          e.preventDefault();
          try {
            setState((prev) => ({
              ...prev,
              openChangeStayLocationPopup: true,
              activityData: data?.data,
            }));
          } catch (error) {
            console.log(error);
          }
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${changeHotelLink ? "6px" : "0px"}`,
          }}
          className="fas fa-home fa-lg"
        />
      </a>
    );
    // open the crew-activity-mobile view for this row’s staff
    let mobileViewLink = data?.data?.employeeNumber && (
      <a
        href="#"
        title="Open Crew Activity view"
        onClick={(e) => {
          e.preventDefault();
          stashGridState(state);
          history.push("/crew-activity-mobile", {
            employeeNumber: data.data.employeeNumber,
            sourceUrl: "/crew-activity",
          });
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${changeHotelLink || changeAddressStayLink ? "6px" : "0px"}`,
          }}
          className="fas fa-mobile-alt fa-lg"
        />
      </a>
    );
    return (
      <div style={{ textAlign: "center" }}>
        {changeHotelLink}
        {changeAddressStayLink}
        {mobileViewLink}
      </div>
    );
  };
  return (
    <>
      <style>{`
        /* ── Crew Activity — theme matching sidebar #8E6448 ── */

        .ca-filter-card {
          background: #ffffff;
          border: none;
          border-radius: 10px;
          box-shadow: 0 2px 12px rgba(142,100,72,0.12);
          padding: 0 !important;
          overflow: hidden;
        }
        .ca-filter-header {
          background: linear-gradient(135deg, #8E6448 0%, #b07d5c 100%);
          padding: 0.55rem 1.1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .ca-filter-header span {
          color: #ffffff;
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.04em;
          text-transform: uppercase;
        }
        .ca-filter-header i {
          color: #FF6600;
          font-size: 0.85rem;
        }
        .ca-filter-body {
          padding: 0.5rem 1rem 0.35rem !important;
        }
        .filter-box {
          margin-bottom: 0px; // 0.35rem;
        }
        .ca-grid-wrap {
          margin-bottom: 0;
        }
        .ca-grid-wrap > .card-body {
          padding: 0.5rem 0.6rem !important;
        }
        .ca-filter-body label {
          font-size: 0.73rem;
          font-weight: 600;
          color: #8E6448;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin-bottom: 0.25rem;
        }
        .ca-filter-row {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          gap: 0.75rem 1rem;
        }
        .ca-filter-field {
          flex: 0 1 240px;
          min-width: 180px;
        }
        .ca-daterange-field {
          /* fixed: just wide enough for "dd/MM/yyyy - dd/MM/yyyy" */
          flex: 0 0 180px;
          min-width: 180px;
        }
        .ca-daterange-wrapper {
          display: block;
          width: 100%;
        }
        .ca-daterange-input {
          display: block;
          width: 100%;
          border: 1px solid #e3d5c6;
          border-radius: 4px;
          background: #fffdfb;
          padding: 5px 9px;
          min-height: 33px;
          font-size: 0.8rem;
          color: #333;
          box-sizing: border-box;
          outline: none;
          transition: border-color 0.15s ease;
        }
        .ca-daterange-input:hover {
          border-color: #d9c3aa;
        }
        .ca-daterange-input:focus {
          border-color: #f4691e;
          box-shadow: none;
        }
        .react-datepicker-popper {
          z-index: 1050;
        }
        .react-datepicker__day--in-range,
        .react-datepicker__day--in-selecting-range,
        .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
          background-color: #fdeee2;
          color: #6b4a2b;
        }
        .react-datepicker__day--keyboard-selected {
          background-color: #fdeee2;
          color: #6b4a2b;
        }
        .react-datepicker__day--range-start,
        .react-datepicker__day--range-end,
        .react-datepicker__day--selecting-range-start,
        .react-datepicker__day--selecting-range-end,
        .react-datepicker__day--selected {
          background-color: #f4691e;
          color: #ffffff;
        }
        .react-datepicker__header {
          background-color: #fdf7f2;
          border-bottom: 1px solid #e8d5c4;
        }
        .ca-daterange-shell {
          display: flex;
          align-items: stretch;
        }
        .ca-daterange-presets {
          display: flex;
          flex-direction: column;
          gap: 2px;
          padding: 8px 6px;
          background: #fdf7f2;
          border-right: 1px solid #e8d5c4;
          min-width: 112px;
        }
        .ca-preset-btn {
          border: none;
          background: transparent;
          text-align: left;
          padding: 6px 10px;
          font-size: 0.78rem;
          font-weight: 600;
          color: #6b4a2b;
          border-radius: 5px;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.15s ease, color 0.15s ease;
        }
        .ca-preset-btn:hover {
          background: #f5e7d8;
        }
        .ca-preset-btn.active {
          background: #f4691e;
          color: #ffffff;
        }
        .ca-daterange-months {
          position: relative;
        }
        .ca-filter-actions {
          display: flex;
          gap: 0.5rem;
          flex-shrink: 0;
          flex-wrap: wrap;
          white-space: nowrap;
          /* offset equal to the field labels so the buttons line up with the inputs */
          padding-top: 27px;
        }
        .ca-filter-actions .btn {
          height: 33px;
          display: inline-flex;
          align-items: center;
          padding-top: 0;
          padding-bottom: 0;
          box-sizing: border-box;
        }

        @media (max-width: 576px) {
          .ca-filter-field,
          .ca-daterange-field,
          .ca-filter-actions {
            flex-basis: 100%;
            min-width: 100%;
          }
          .ca-filter-actions {
            justify-content: flex-start;
            padding-top: 0;
          }
        }

        /* DataGrid header row */
        .ca-grid-wrap .dx-header-row td {
          background-color: #fff0e6 !important;
          color: #000000 !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .ca-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .ca-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .ca-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          border-bottom: 1px solid #e8d5c4 !important;
          padding: 0.35rem 0.6rem !important;
        }

        .dx-datagrid-header-panel .dx-toolbar
        {
          margin-bottom: 5px !important
        }
        .ca-grid-subtoolbar {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-end;
          justify-content: space-between;
          gap: 0.75rem;
          background: #fdf7f2;
          border: 1px solid #e8d5c4;
          border-bottom: none;
          border-radius: 8px 8px 0 0;
          padding: 0.5rem 0.75rem;
        }
        .ca-grid-subtoolbar-filters {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-end;
          gap: 0.75rem;
        }
        .ca-grid-subtoolbar label {
          display: block;
          font-size: 0.7rem;
          font-weight: 600;
          color: #8E6448;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin-bottom: 0.25rem;
        }
        .ca-grid-refresh-btn {
          height: 31px;
          width: 31px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
      `}</style>

      <div className="filter-box">
        <div className="card ca-filter-card p-0 m-0">
          <div className="ca-filter-body">
            <div className="ca-filter-row">
              <div className="ca-filter-field">
                <div className="form-group mb-0">
                  <label>Staff ID</label>
                  <DropDownBox
                    ref={refDropDownOperator}
                    value={state.filterEmployeeNumber}
                    valueExpr="employeeNumber"
                    displayExpr="employeeFullName"
                    deferRendering={false}
                    showClearButton={true}
                    dataSource={state.filterDropdownEmployeeDataSource}
                    onValueChanged={() => {
                      if (refLstEmployees.current?.instance) {
                        refLstEmployees.current.instance.unselectAll();
                        refLstEmployees.current.instance.option(
                          "searchValue",
                          "",
                        );
                      }
                      setState((prev) => ({
                        ...prev,
                        filterEmployeeNumber: "",
                      }));
                    }}
                    contentRender={() => {
                      return (
                        <List
                          ref={refLstEmployees}
                          //dataSource={state.filterDropdownEmployeeDataSource}
                          dataSource={
                            new DataSource({
                              store: state.filterDropdownEmployeeDataSource,
                              // sort: [
                              //   "Position",
                              //   { selector: "employeeName", desc: true },
                              // ],
                              sort: "employeeName",
                              sortOrder: "asc",
                              paginate: true,
                              pageSize: 10,
                            })
                          }
                          height={400}
                          keyExpr="employeeNumber"
                          displayExpr="employeeFullName"
                          searchEnabled={true}
                          searchExpr={[
                            "employeeNumber",
                            "employeeName",
                            "employeeFullName",
                          ]}
                          searchMode="contains"
                          pageLoadMode="scrollBottom"
                          showSelectionControls={true}
                          selectionMode={"single"}
                          indicateLoading={true}
                          selectByClick={true}
                          onItemClick={(item) => {
                            try {
                              setState((prev) => ({
                                ...prev,
                                filterEmployeeNumber:
                                  item?.itemData?.employeeNumber ?? "",
                              }));
                              refDropDownOperator.current.instance.close();
                            } catch (error) {
                              console.log("List.onItemClick", error);
                            }
                          }}
                          // onSelectionChanged={() => {
                          //   try {
                          //     let filterEmployeeNumber =
                          //       state.filterEmployeeNumber;
                          //     if (refLstEmployees.current) {
                          //       filterEmployeeNumber =
                          //         refLstEmployees.current.instance.option()
                          //           .selectedItemKeys[0] ?? "";
                          //     }
                          //     setState((prev) => ({
                          //       ...prev,
                          //       filterEmployeeNumber: filterEmployeeNumber,
                          //     }));
                          //   } catch (error) {
                          //     console.log("onSelectionChanged", error);
                          //   }
                          // }}
                          itemRender={(item) => (
                            <p className="mb-0">
                              {item.employeeName}
                              <span className="text-muted">
                                {item?.employeeNumber && (
                                  <>
                                    <br />
                                    <small style={{ fontSize: "11px" }}>
                                      <i className="fas fa-user" />
                                      {` ${item?.employeeNumber}`}
                                    </small>
                                  </>
                                )}
                              </span>
                            </p>
                          )}
                        />
                      );
                    }}
                    placeholder="Select Staff"
                  />
                </div>
              </div>
              <div className="ca-filter-field">
                <div className="form-group mb-0">
                  <label>Airport</label>
                  <SelectBox
                    dataSource={state.filterDropdownAirportDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Airport"
                    value={state.filterAirportCode}
                    displayExpr="airportName"
                    valueExpr="airportCode"
                    showClearButton={true}
                    searchEnabled={true}
                    onValueChanged={async (e) => {
                      let filterAirportCode = e.value ?? "";
                      setState((prev) => ({
                        ...prev,
                        filterAirportCode: filterAirportCode,
                        filterHotelId: 0,
                      }));
                      await GetFilterDropdownHotel(filterAirportCode);
                    }}
                  />
                </div>
              </div>
              <div className="ca-filter-field">
                <div className="form-group mb-0">
                  <label>Hotel</label>
                  <SelectBox
                    dataSource={state.filterDropdownHotelDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Hotel"
                    defaultValue={state.filterHotelId}
                    displayExpr="hotelName"
                    valueExpr="hotelId"
                    showClearButton={true}
                    searchEnabled={true}
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        filterHotelId: e.value ?? 0,
                      }));
                    }}
                  />
                  {state.filterHotelApiLoading && (
                    <i
                      className="fas fa-spinner fa-spin text-green"
                      style={{
                        float: "right",
                        marginTop: "-22px",
                        marginRight: "12px",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="ca-filter-field ca-daterange-field">
                <div className="form-group mb-0">
                  <label>From - To Date (Check-in)</label>
                  <ReactDatePicker
                    ref={refDateRangePicker}
                    calendarContainer={renderDateRangeCalendarContainer}
                    selectsRange={true}
                    startDate={
                      state.filterFromDatetime
                        ? moment(state.filterFromDatetime).toDate()
                        : null
                    }
                    endDate={
                      state.filterToDatetime
                        ? moment(state.filterToDatetime).toDate()
                        : null
                    }
                    onChange={([start, end]) => {
                      setState((prev) => ({
                        ...prev,
                        filterFromDatetime: start,
                        filterToDatetime: end,
                      }));
                    }}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/MM/yyyy - dd/MM/yyyy"
                    onChangeRaw={(e) => e.preventDefault()}
                    className="ca-daterange-input"
                    wrapperClassName="ca-daterange-wrapper"
                    monthsShown={2}
                    showPopperArrow={false}
                    portalId="ca-daterange-portal"
                  />
                </div>
              </div>
              <div className="ca-filter-actions">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    await handleOnFilterGridDataSource();
                  }}
                >
                  <span title="Search">
                    <i
                      className={`fas fa-${
                        state.isFilterSubmitted ? "spinner fa-spin" : "search"
                      }`}
                    ></i>
                    &nbsp;Search
                  </span>
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      filterEmployeeNumber: "",
                      filterAirportCode: "",
                      filterHotelId: 0,
                      filterFromDatetime: new Date(moment().startOf("day")),
                      filterToDatetime: new Date(moment().endOf("day")),
                    }));
                  }}
                >
                  <span title="Clear">
                    <i className="fas fa-eraser"></i> Clear
                  </span>
                </button>
              </div>
            </div>
          </div>
          {/* end ca-filter-body */}
        </div>
      </div>
      {/* datagrid */}
      <div className="card ca-grid-wrap">
        <div className="card-body">
          <div>
            {state.isActivityApiLoading && (
              <DataGridSkeletonPageSimpleWithTitle />
            )}
            {!state.isActivityApiLoading && (
              <>
                <div className="ca-grid-subtoolbar">
                  <div className="ca-grid-subtoolbar-filters">
                    <div className="form-group mb-0">
                      <label>Duty Type</label>
                      <SelectBox
                        dataSource={DutyTypeLst}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select duty type"
                        name="dutyTypeDropdown"
                        width={170}
                        defaultValue={0}
                        value={state.dutyTypeId}
                        displayExpr="name"
                        valueExpr="id"
                        onValueChanged={(e) => {
                          let dutyTypeId = e.value ?? 0;
                          try {
                            setState((prev) => ({
                              ...prev,
                              dutyTypeId: dutyTypeId,
                            }));
                            filterActivityDataGridDutyTypeWise(
                              dutyTypeId,
                              state.timeSlotId,
                              state.crewActivityLst,
                              state.hotelFilter,
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        showClearButton={true}
                        searchEnabled={true}
                      />
                    </div>
                    <div className="form-group mb-0">
                      <label>Time Slot</label>
                      <SelectBox
                        dataSource={TimeSlotList}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="All Time"
                        name="timeSlotDropdown"
                        width={165}
                        defaultValue={0}
                        value={state.timeSlotId}
                        displayExpr="name"
                        valueExpr="id"
                        onValueChanged={(e) => {
                          try {
                            const timeSlotId = e.value ?? 0;
                            setState((prev) => ({
                              ...prev,
                              timeSlotId: timeSlotId,
                            }));
                            filterActivityDataGridDutyTypeWise(
                              state.dutyTypeId,
                              timeSlotId,
                              state.crewActivityLst,
                              state.hotelFilter,
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        showClearButton={true}
                        searchEnabled={false}
                      />
                    </div>
                    <div className="form-group mb-0">
                      <label>Hotel Filter</label>
                      <SelectBox
                        dataSource={[
                          { id: "all", name: "All Records" },
                          { id: "changeHotel", name: "Change Hotel" },
                        ]}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        name="hotelFilterDropdown"
                        width={165}
                        value={state.hotelFilter}
                        displayExpr="name"
                        valueExpr="id"
                        onValueChanged={(e) => {
                          try {
                            const hotelFilter = e.value ?? "all";
                            setState((prev) => ({
                              ...prev,
                              hotelFilter: hotelFilter,
                            }));
                            filterActivityDataGridDutyTypeWise(
                              state.dutyTypeId,
                              state.timeSlotId,
                              state.crewActivityLst,
                              hotelFilter,
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        searchEnabled={false}
                      />
                    </div>
                  </div>
                  {/* <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm ca-grid-refresh-btn"
                    title="Refresh"
                    disabled={state.isToolbarRefreshing}
                    onClick={handleToolbarRefresh}
                  >
                    <i
                      className={`fas fa-${state.isToolbarRefreshing ? "spinner fa-spin" : "sync-alt"}`}
                    />
                  </button> */}
                </div>
                <DataGrid
                  ref={refDataGrid}
                  dataSource={state.crewActivityGridDataSource}
                  // dataSource={
                  //   new DataSource({
                  //     store: state.crewActivityGridDataSource?.filter(
                  //       (f) =>
                  //         state.dutyTypeId === 0 ||
                  //         (state.dutyTypeId === 1 &&
                  //           (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
                  //         (state.dutyTypeId === 2 && f.activityTypeId === 2)
                  //     ),
                  //   })
                  // }
                  showBorders={true}
                  columnAutoWidth={true}
                  allowColumnResizing={true}
                  showRowLines={true}
                  showColumnLines={true}
                  rowAlternationEnabled={false}
                  repaintChangesOnly={true}
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#8E6448";
                      e.cellElement.style.color = "#ffffff";
                    }
                    if (e.rowType === "data") {
                      if (e.column.dataField === "id") {
                        e.cellElement.style.backgroundColor = "#f5ede4";
                      }
                      if (e.column.dataField !== "id") {
                        if (e.data.activityTypeId === 1) {
                          // Fly duty — warm white
                          e.cellElement.style.backgroundColor = "#fffaf6";
                          e.cellElement.style.color = "#3d1f00";
                        }
                        if (e.data.activityTypeId === 2) {
                          // Non-fly duty — soft amber tint
                          e.cellElement.style.backgroundColor = "#fdf0e4";
                          e.cellElement.style.color = "#5c3a1e";
                        }
                        if (e.data.allowAllocateHotel) {
                          // Hotel allocation — keep green for status clarity
                          e.cellElement.style.backgroundColor = "#e6f4ea";
                          e.cellElement.style.color = "#1e5631";
                        }
                      }
                    }
                  }}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarDataFilterTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    caption=""
                    allowSorting={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowFiltering={false}
                    fixed={true}
                    width={"40"}
                    cellRender={cellRender}
                  />
                  <Column
                    dataField="activityType"
                    caption="Duty Type"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="activityDisplay"
                    caption="Activity/Flight Number"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={180}
                    cellRender={(data) => {
                      if (
                        data.data?.activityLocationCode &&
                        !data.data?.isGroundDutyPickup
                      ) {
                        return (
                          <div className="mergeData ellipsis">
                            <span className="text-muted">
                              <i className="fas fa-map-marker-alt fa-xs" />
                            </span>{" "}
                            {`${data.data?.activityCode ?? ""}`}
                            <br />
                            <span className="text-muted">
                              <i className="fas fa-building fa-xs"></i>
                            </span>{" "}
                            {`${data.data?.activityLocationCode ?? ""}`}
                          </div>
                        );
                      }
                      if (
                        data.data?.activityLocationCode &&
                        data.data?.isGroundDutyPickup
                      ) {
                        return (
                          <div className="mergeData ellipsis">
                            <span className="text-muted">
                              <i className="fas fa-building fa-xs"></i>
                            </span>{" "}
                            {`${data.data?.activityLocationCode ?? ""}`}
                            <br />
                            <span className="text-muted">
                              <i className="fas fa-map-marker-alt fa-xs" />
                            </span>{" "}
                            {`${data.data?.activityCode ?? ""}`}
                          </div>
                        );
                      }
                      return (
                        <div className="mergeData ellipsis">
                          <span className="text-muted">
                            <i className="fas fa-plane-departure"></i>
                          </span>{" "}
                          <span>{data.data.activityDisplay}</span>
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="employeeNumber"
                    caption="Staff ID #"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="fullName"
                    caption="Staff Name"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="airlineCrewType"
                    caption="Staff Rank"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="crewBaseStation"
                    caption="Staff Base"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Pick-up/Drop Airport"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="nextDutyAirport"
                    caption="Next Duty Start Airport"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="transportationCompany"
                    caption="Transporter"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />

                  <Column
                    dataField="pickupLocation"
                    caption="Pickup"
                    width={200}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="dropOffLocation"
                    caption="Dropoff"
                    width={200}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="flightTime"
                    caption="Flight Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="pickupTime"
                    caption="Pickup Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="dutyReportingTime"
                    caption="Reporting Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="deBriefingTime"
                    caption="DeBriefing Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="dropoffTime"
                    caption="Dropoff Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="activityStartTime"
                    caption="Activity Start Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="activityEndTime"
                    caption="Activity End Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="flightNumber"
                    caption="Flight #"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="flightArrivalTerminal"
                    caption="Arrival Terminal"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="flightDepartureTerminal"
                    caption="Departure Terminal"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="activityLocationCode"
                    caption="Activity Location Code"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="transactionId"
                    caption="Transaction #"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="tripId"
                    caption="Tracking #"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType={"string"}
                    cellRender={(data) => data?.data?.tripId || ""}
                  />
                  <Column
                    dataField="tripTypeName"
                    caption="Trip Type"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Template
                    name="toolbarDataFilterTemplate"
                    render={() => {
                      return (
                        <>
                          <span>
                            <i className={`fas fa-clock`}></i> Crew Activity
                            <span className="ml-2">
                              [{" "}
                              {moment(state.filterFromDatetime).format(
                                `DD/MM/yyyy HH:mm`,
                              )}
                              {" - "}
                              {moment(
                                state.filterToDatetime ??
                                  state.filterFromDatetime,
                              ).format(`DD/MM/yyyy HH:mm`)}{" "}
                              ]
                            </span>
                          </span>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={true} />
                  <Paging defaultPageSize={10} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="CrewActivity"
                  />
                </DataGrid>
              </>
            )}
          </div>
        </div>
      </div>
      {state.openChangeStayLocationPopup && (
        <ChangeStayLocationAddress
          isHotelDropoff={
            state.activityData?.tripTypeId === 2 ||
            state.activityData?.tripTypeId === 10 ||
            state.activityData?.tripTypeId === 16
          }
          airlineCode={state.activityData.airlineCode}
          employeeNumber={state.activityData.employeeNumber}
          airportCode={state.activityData.airportCode}
          id={state.activityData.id}
          hotelName={
            state.activityData?.tripTypeId === 2 ||
            state.activityData?.tripTypeId === 10 ||
            state.activityData?.tripTypeId === 16
              ? state.activityData?.dropOffHotelName || ""
              : state.activityData?.hotelName || ""
          }
          isHotelCancel={true}
          isTransporterRequired={true}
          onRefresh={async () => await getCrewActivities()}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openChangeStayLocationPopup: false,
              airlineCode: "",
              activityData: null,
            }));
          }}
        />
      )}
      {state.openChangeHotelPopup && (
        <ChangeHotelModal
          activityData={state.activityData}
          onRefresh={async () => {
            try {
              await getCrewActivities();
            } catch (error) {
              console.log(error);
            }
          }}
          onClose={async () => {
            try {
              setState((prev) => ({
                ...prev,
                openChangeHotelPopup: false,
                activityData: null,
              }));
            } catch (error) {
              console.log(error);
            }
          }}
        />
      )}
    </>
  );
}

function ChangeStayLocationAddress(props) {
  const [state, setState] = useState({
    dropdownAirportDataSource: [],
    stationAirports: [],
    airlineCode: props?.airlineCode || "",
    employeeNumber: props?.employeeNumber || "",
    airportCode: props?.airportCode || "",
    id: props?.id || 0,
    isHotelCancel: props.isHotelCancel,
    isTransporterRequired: props.isTransporterRequired,
    isOpenSelectAddressModal: false,
    crewAddressDropdownDataSource: [],
    latitude: "",
    longitude: "",
    addressId: 0,
    address: "",
    postalCode: "",
    hotelName: "",
    modalErrors: {
      employeeNumber: "",
      airportCode: "",
      airlineCode: "",
      latitude: "",
      longitude: "",
      address: "",
      postalCode: "",
    },
  });
  const GetDropdownAirportDataSource = async () => {
    try {
      const airportDropdownData = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      setState((prev) => ({
        ...prev,
        dropdownAirportDataSource: airportDropdownData?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetStationAirports = async () => {
    try {
      const response = await axiosGet(`Crew/get-station_airports`, {
        airportCode: state.airportCode,
      });
      setState((prev) => ({
        ...prev,
        stationAirports: response?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const isValid = () => {
    let isValid = true;
    try {
      let err = state.modalErrors;
      err.airportCode = "";
      err.latitude = "";
      err.longitude = "";
      err.postalCode = "";
      err.address = "";
      if (!state.airportCode) {
        isValid = false;
        err.airportCode = "Please select airport code";
      }
      if (!state.latitude) {
        isValid = false;
        err.latitude = "Please enter latitude";
      }
      if (!state.longitude) {
        isValid = false;
        err.longitude = "Please enter longitude";
      }
      if (!state.postalCode) {
        isValid = false;
        err.postalCode = "Please enter postal code";
      }
      if (!state.address) {
        isValid = false;
        err.address = "Please enter address";
      } else {
        if (state.addressId === 0) {
          isValid = false;
          err.address = "Please select valid address";
        }
      }

      setState((prev) => ({ ...prev, modalErrors: err }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnChangeStayLocation = async (e) => {
    e.preventDefault();
    try {
      if (isValid()) {
        let request = {};
        request.AirlineCode = state.airlineCode;
        request.AirportCode = state.airportCode;
        request.EmployeeNumber = state.employeeNumber;
        request.CzReservationId = state.id;
        request.IsHotelCancel = state.isHotelCancel;
        request.TransporterRequired = state.isTransporterRequired;
        request.AddressId = state.addressId;
        request.AddressInfo = state.address;
        request.PostalCode = state.postalCode;
        request.Latitude = state.latitude;
        request.Longitude = state.longitude;
        request.DeviceTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        setState((prev) => ({ ...prev, isSubmitted: true }));
        const data = await axiosPost(
          "CrewActivity/change-stay-location",
          request,
        );
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (data?.isSuccess) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: data?.message,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await props.onRefresh();
              props.onClose();
            }
          });
        } else {
          await showErrorMessage(data?.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewAddressList = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      var request = {};
      request.AirlineCode = airlineCode;
      request.EmployeeNo = state.employeeNumber;
      const response = await axiosPost("Crew/get-address", request);
      const data = response?.payload ?? response ?? [];
      const filteredData = data.filter((el) =>
        state.stationAirports.find((element) => element === el.baseStation),
      );

      setState((prev) => ({
        ...prev,
        crewAddressDropdownDataSource: filteredData ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const handelOnAddressChange = (e) => {
    try {
      let err = state.modalErrors;
      err.address = "";
      err.postalCode = "";
      err.latitude = "";
      err.longitude = "";
      const { rowIndex, address, postalCode, latitude, longitude } = {
        ...(e.selectedItem ?? null),
      };
      setState((prev) => ({
        ...prev,
        addressId: rowIndex || 0,
        address: address || "",
        postalCode: postalCode || "",
        latitude: latitude || 0,
        longitude: longitude || 0,
        modalErrors: err,
      }));
    } catch (error) {}
  };
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          await GetStationAirports();
          await getCrewAddressList();
        }}
        onAfterClose={() => {
          setState((prev) => ({
            ...prev,
            dropdownAirportDataSource: [],
            stationAirports: [],
            employeeNumber: "",
            airlineCode: "",
            airportCode: "",
            latitude: "",
            longitude: "",
            id: 0,
            addressId: 0,
            address: "",
            postalCode: "",
            isHotelCancel: false,
            isTransporterRequired: false,
            hotelName: "",
            modalErrors: {
              employeeNumber: "",
              airportCode: "",
              airlineCode: "",
              latitude: "",
              longitude: "",
              address: "",
              postalCode: "",
            },
          }));
        }}
        style={{
          content: {
            width: "55%",
            padding: 0,
            borderRadius: 10,
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <i
              className={`fas fa-${props?.isHotelDropoff ? "map-marker-alt" : "map-pin"}`}
              style={{ color: "#fff", fontSize: 18 }}
            />
            <div>
              <h6
                style={{
                  margin: 0,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                {props?.isHotelDropoff
                  ? "Change / Cancel Hotel Drop-off"
                  : "Change / Cancel Hotel Pick-up"}{" "}
                Address
              </h6>
              {props?.hotelName && (
                <span
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    color: "#fff",
                    borderRadius: 20,
                    padding: "2px 10px",
                    fontSize: 11,
                    marginTop: 3,
                    display: "inline-block",
                  }}
                >
                  <i className="fas fa-hotel" style={{ marginRight: 4 }} />
                  {props.hotelName}
                </span>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={() => props.onClose()}
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: 32,
              height: 32,
              cursor: "pointer",
              color: "#fff",
              fontSize: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "16px 18px",
            background: "#f4f6f9",
            overflowY: "auto",
            maxHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          {/* Crew Info Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-id-card"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Crew Information
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Staff ID
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ background: "#e9ecef" }}
                      >
                        <i
                          className="fas fa-id-badge text-muted"
                          style={{ fontSize: 11 }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.employeeNumber}
                      readOnly
                      style={{
                        background: "#f8f9fa",
                        fontWeight: 600,
                        color: "#343a40",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Pick-up / Drop Airport
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ background: "#e9ecef" }}
                      >
                        <i
                          className="fas fa-plane text-muted"
                          style={{ fontSize: 11 }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.airportCode}
                      readOnly
                      style={{
                        background: "#f8f9fa",
                        fontWeight: 600,
                        color: "#343a40",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Location Coordinates Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-map-marked-alt"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Location Coordinates
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Latitude <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{
                          background: "#e3f2fd",
                          color: "#1565c0",
                          fontWeight: 700,
                          fontSize: 10,
                          minWidth: 36,
                          justifyContent: "center",
                        }}
                      >
                        LAT
                      </span>
                    </div>
                    <input
                      type="text"
                      className={`form-control form-control-sm${state.modalErrors.latitude ? " is-invalid" : ""}`}
                      placeholder="e.g. 25.2048"
                      value={state.latitude}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "" || RegEx.LatLong.test(value)) {
                          setState((prev) => ({ ...prev, latitude: value }));
                        }
                      }}
                    />
                  </div>
                  {state.modalErrors.latitude?.length > 0 && (
                    <div
                      className="text-danger"
                      style={{ fontSize: 11, marginTop: 3 }}
                    >
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ marginRight: 3 }}
                      />
                      {state.modalErrors.latitude}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Longitude <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{
                          background: "#e3f2fd",
                          color: "#1565c0",
                          fontWeight: 700,
                          fontSize: 10,
                          minWidth: 36,
                          justifyContent: "center",
                        }}
                      >
                        LNG
                      </span>
                    </div>
                    <input
                      type="text"
                      className={`form-control form-control-sm${state.modalErrors.longitude ? " is-invalid" : ""}`}
                      placeholder="e.g. 55.2708"
                      value={state.longitude}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "" || RegEx.LatLong.test(value)) {
                          setState((prev) => ({ ...prev, longitude: value }));
                        }
                      }}
                    />
                  </div>
                  {state.modalErrors.longitude?.length > 0 && (
                    <div
                      className="text-danger"
                      style={{ fontSize: 11, marginTop: 3 }}
                    >
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ marginRight: 3 }}
                      />
                      {state.modalErrors.longitude}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Postal Code <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ background: "#e9ecef" }}
                      >
                        <i
                          className="fas fa-envelope text-muted"
                          style={{ fontSize: 11 }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      className={`form-control form-control-sm${state.modalErrors.postalCode ? " is-invalid" : ""}`}
                      placeholder="Enter postal code"
                      value={state.postalCode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "" || value.length <= 7) {
                          setState((prev) => ({ ...prev, postalCode: value }));
                        }
                      }}
                    />
                  </div>
                  {state.modalErrors.postalCode?.length > 0 && (
                    <div
                      className="text-danger"
                      style={{ fontSize: 11, marginTop: 3 }}
                    >
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ marginRight: 3 }}
                      />
                      {state.modalErrors.postalCode}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Address Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-map-marker-alt"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Address
            </div>
            <div className="form-group mb-0">
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#495057",
                  marginBottom: 4,
                  display: "block",
                }}
              >
                Selected Address <span className="text-danger">*</span>
              </label>
              <div className="input-group input-group-sm">
                <input
                  type="text"
                  className={`form-control form-control-sm${state.modalErrors.address ? " is-invalid" : ""}`}
                  placeholder="Click 'Select Address' to choose..."
                  value={state.address}
                  readOnly
                  style={{
                    background: state.address ? "#fff" : "#f8f9fa",
                    cursor: "default",
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    style={{ fontSize: 12, whiteSpace: "nowrap" }}
                    onClick={async () => {
                      try {
                        setState((prev) => ({
                          ...prev,
                          isOpenSelectAddressModal: true,
                        }));
                        await getCrewAddressList();
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <i
                      className="fas fa-search-location"
                      style={{ marginRight: 5 }}
                    />
                    Select Address
                  </button>
                </div>
              </div>
              {state.modalErrors.address?.length > 0 && (
                <div
                  className="text-danger"
                  style={{ fontSize: 11, marginTop: 3 }}
                >
                  <i
                    className="fas fa-exclamation-circle"
                    style={{ marginRight: 3 }}
                  />
                  {state.modalErrors.address}
                </div>
              )}
            </div>
          </div>

          {/* Options Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-sliders-h"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Options
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {props?.isHotelDropoff && (
                <div
                  style={{
                    flex: "1 1 220px",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: state.isHotelCancel ? "#fff8e1" : "#f8f9fa",
                    border: `1px solid ${state.isHotelCancel ? "#ffc107" : "#dee2e6"}`,
                    borderRadius: 6,
                    padding: "10px 14px",
                    cursor: "pointer",
                    transition: "all 0.15s",
                  }}
                  onClick={() =>
                    setState((prev) => ({
                      ...prev,
                      isHotelCancel: !prev.isHotelCancel,
                    }))
                  }
                >
                  <CheckBox
                    id="isHotelCancel"
                    value={state.isHotelCancel}
                    onValueChanged={(e) =>
                      setState((prev) => ({ ...prev, isHotelCancel: e.value }))
                    }
                  />
                  <label
                    htmlFor="isHotelCancel"
                    style={{
                      margin: 0,
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 500,
                      color: state.isHotelCancel ? "#856404" : "#495057",
                    }}
                  >
                    <i
                      className="fas fa-hotel"
                      style={{
                        marginRight: 5,
                        color: state.isHotelCancel ? "#f0ad4e" : "#6c757d",
                      }}
                    />
                    Cancel Hotel
                  </label>
                </div>
              )}
              <div
                style={{
                  flex: "1 1 220px",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  background: state.isTransporterRequired
                    ? "#e8f5e9"
                    : "#f8f9fa",
                  border: `1px solid ${state.isTransporterRequired ? "#28a745" : "#dee2e6"}`,
                  borderRadius: 6,
                  padding: "10px 14px",
                  cursor: "pointer",
                  transition: "all 0.15s",
                }}
                onClick={() =>
                  setState((prev) => ({
                    ...prev,
                    isTransporterRequired: !prev.isTransporterRequired,
                  }))
                }
              >
                <CheckBox
                  id="isTransporterRequired"
                  value={state.isTransporterRequired}
                  onValueChanged={(e) =>
                    setState((prev) => ({
                      ...prev,
                      isTransporterRequired: e.value,
                    }))
                  }
                />
                <label
                  htmlFor="isTransporterRequired"
                  style={{
                    margin: 0,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                    color: state.isTransporterRequired ? "#155724" : "#495057",
                  }}
                >
                  <i
                    className="fas fa-bus"
                    style={{
                      marginRight: 5,
                      color: state.isTransporterRequired
                        ? "#28a745"
                        : "#6c757d",
                    }}
                  />
                  Transporter Required
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            background: "#fff",
            borderTop: "1px solid #dee2e6",
            padding: "10px 18px",
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={state.isSubmitted}
            style={{ minWidth: 110, fontWeight: 600 }}
            onClick={async (e) => {
              await handleOnChangeStayLocation(e);
            }}
          >
            {state.isSubmitted ? (
              <>
                <i
                  className="fas fa-spinner fa-spin"
                  style={{ marginRight: 5 }}
                />
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save" style={{ marginRight: 5 }} />
                Submit
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            style={{ minWidth: 90, fontWeight: 600 }}
            onClick={() => props.onClose()}
          >
            <i className="fas fa-times" style={{ marginRight: 5 }} />
            Close
          </button>
        </div>
      </Modal>

      {state.isOpenSelectAddressModal && (
        <ShowSelectAddressModal
          airportCode={state.airportCode}
          crewAddressDropdownDataSource={state.crewAddressDropdownDataSource}
          addressId={state.addressId}
          handelOnAddressChange={(e) => {
            handelOnAddressChange(e);
          }}
          Close={(isAddressSelected) => {
            if (isAddressSelected) {
              setState((prev) => ({
                ...prev,
                isOpenSelectAddressModal: false,
              }));
            } else {
              setState((prev) => ({
                ...prev,
                addressId: 0,
                isOpenSelectAddressModal: false,
              }));
            }
          }}
        />
      )}
    </>
  );
}
function ShowSelectAddressModal(props) {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{
          content: {
            width: "35%",
            padding: 0,
            borderRadius: 10,
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            padding: "14px 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <i
              className="fas fa-map-marker-alt"
              style={{ color: "#fff", fontSize: 16 }}
            />
            <div>
              <h6
                style={{
                  margin: 0,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Select Address
              </h6>
              <span style={{ color: "rgba(255,255,255,0.85)", fontSize: 11 }}>
                Airport: <strong>{props.airportCode}</strong>
              </span>
            </div>
          </div>
          <button
            type="button"
            onClick={() => props.Close(false)}
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: 30,
              height: 30,
              cursor: "pointer",
              color: "#fff",
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "18px 20px", background: "#f4f6f9" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <label
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#495057",
                marginBottom: 6,
                display: "block",
              }}
            >
              <i
                className="fas fa-map-marker-alt"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Choose Address <span className="text-danger">*</span>
            </label>
            <SelectBox
              dataSource={props.crewAddressDropdownDataSource}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Search and select address..."
              name="address"
              value={props.addressId}
              displayExpr="address"
              valueExpr="rowIndex"
              onSelectionChanged={(e) => {
                props.handelOnAddressChange(e);
              }}
              showClearButton={true}
              disabled={false}
              searchEnabled={true}
            />
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            background: "#fff",
            borderTop: "1px solid #dee2e6",
            padding: "12px 18px",
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            className="btn btn-success btn-sm"
            style={{ minWidth: 130, fontWeight: 600 }}
            onClick={() => props.Close(true)}
          >
            <i className="fas fa-check" style={{ marginRight: 5 }} />
            Select & Close
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            style={{ minWidth: 90, fontWeight: 600 }}
            onClick={() => props.Close(false)}
          >
            <i className="fas fa-times" style={{ marginRight: 5 }} />
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
function ChangeHotelModal(props) {
  const [state, setState] = useState({
    isSubmitted: false,
    hotelDropdownDataSource: [],
    hotelId: 0,
    hotelName: "",
    hotelAddress: "",
    hotelTransfer: "",
    isHotelTransferLoaded: false,
    errors: {
      hotel: "",
    },
  });
  const getHotelDropdown = async () => {
    try {
      const response = await axiosPost(
        `CreweasyMobile/get-allocate-hotel-list`,
        {
          AirlineCode: props?.activityData?.airlineCode,
          TransactionId: props?.activityData?.transactionId,
          EmployeeNumber: props?.activityData?.employeeNumber,
          LocationCode: props?.activityData?.activityLocationCode,
        },
      );
      let hotelDropdown = (response?.payload || []).filter(
        (h) =>
          h.id !== props?.activityData?.hotelId &&
          h.id !== props?.activityData?.dropOffHotelId,
      );
      setState((prev) => ({ ...prev, hotelDropdownDataSource: hotelDropdown }));
    } catch (error) {
      console.log(error);
    }
  };
  const getHotelTransfer = async (hotelCode) => {
    try {
      setState((prev) => ({ ...prev, isHotelTransferLoaded: true }));
      const response = await axiosGet(`Hotel/get-hotel-transfer`, {
        TransactionId: props?.activityData?.transactionId,
        EmployeeNumber: props?.activityData?.employeeNumber,
        hotelCode: hotelCode,
      });
      let hotelTransfer = response?.payload?.transporterName || "";
      setState((prev) => ({
        ...prev,
        hotelTransfer: hotelTransfer,
        isHotelTransferLoaded: false,
      }));
    } catch (error) {
      setState((prev) => ({ ...prev, isHotelTransferLoaded: false }));
      console.log(error);
    }
  };

  const isValidData = () => {
    let isValid = true;
    try {
      let err = { ...state.errors };
      err.hotel = "";
      if (state.hotelId === 0) {
        isValid = false;
        err.hotel = "Please select hotel";
      }
      setState((prev) => ({ ...prev, errors: err }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnChangeHotel = async (e) => {
    e.preventDefault();
    try {
      if (isValidData()) {
        let confirmationQuestion = `Are you sure you want to change <br/>the hotel to <strong>${state.hotelName}? </strong>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No",
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        const response = await axiosPost(`CreweasyMobile/change-hotel`, {
          AirlineCode: props?.activityData?.airlineCode,
          TransactionId: props?.activityData?.transactionId,
          EmployeeNumber: props?.activityData?.employeeNumber,
          HotelId: state.hotelId,
          DeviceTime: moment(new Date()).format(
            DateFormat.SqlDateTimeFullFormat,
          ),
        });
        debugger;
        isConfirmed = await showResponseMessage({
          isSuccess: response.success,
          message: response.message,
        });
        setState((prev) => ({ ...prev, isSubmitted: false }));

        if (isConfirmed) {
          if (response?.success) {
            props.onRefresh();
            props.onClose();
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-medium"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          try {
            await getHotelDropdown();
          } catch (error) {
            console.log(error);
          }
        }}
        onAfterClose={() => {
          try {
            setState((prev) => ({
              ...prev,
              isSubmitted: false,
              hotelDropdownDataSource: [],
              hotelId: 0,
              hotelName: "",
              hotelAddress: "",
              hotelTransfer: "",
              isHotelTransferLoaded: false,
              errors: {
                hotel: "",
              },
            }));
          } catch (error) {
            console.log(error);
          }
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">Change Hotel</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  background:
                    "linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%)",
                  borderRadius: "10px",
                  padding: "12px 16px",
                  marginBottom: "10px",
                }}
              >
                {props?.activityData?.crewProfilePhotoURL ? (
                  <img
                    src={props.activityData.crewProfilePhotoURL}
                    alt="crew"
                    style={{
                      width: "46px",
                      height: "46px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      flexShrink: 0,
                      border: "2px solid rgba(255,255,255,0.25)",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "46px",
                      height: "46px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.15)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      border: "2px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    <i
                      className="fas fa-user"
                      style={{ color: "#fff", fontSize: "18px" }}
                    ></i>
                  </div>
                )}
                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: "0.95rem",
                      color: "#ffffff",
                      letterSpacing: "0.01em",
                    }}
                  >
                    {`${props?.activityData?.firstName || ""} ${props?.activityData?.lastName || ""}`.trim()}
                  </div>
                  <div
                    style={{
                      fontSize: "0.75rem",
                      color: "rgba(255,255,255,0.55)",
                      marginTop: "2px",
                    }}
                  >
                    <i
                      className="fas fa-id-badge"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Crew Member
                    {props?.activityData?.crewRank && (
                      <span
                        style={{
                          marginLeft: "8px",
                          background: "rgba(255,255,255,0.12)",
                          borderRadius: "4px",
                          padding: "1px 7px",
                        }}
                      >
                        {props.activityData.crewRank}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {(props?.activityData?.activityDisplay ||
              props?.activityData?.transportationCompany) && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div
                  style={{
                    background: "#f0f4ff",
                    border: "1px solid #d0d9f0",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    marginBottom: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                  }}
                >
                  {props?.activityData?.activityDisplay && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: "6px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          flex: 1,
                        }}
                      >
                        <i
                          className="fas fa-tasks"
                          style={{
                            color: "#4f6ef7",
                            fontSize: "13px",
                            flexShrink: 0,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "0.82rem",
                            color: "#3d4a6b",
                            fontWeight: 600,
                          }}
                        >
                          {props.activityData.activityDisplay}
                        </span>
                      </span>
                      {props?.activityData?.activityTimeDisplay && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            flex: 1,
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="far fa-clock"
                            style={{
                              color: "#8E6448",
                              fontSize: "12px",
                              flexShrink: 0,
                            }}
                          />
                          <span
                            style={{
                              fontSize: "0.78rem",
                              color: "#8E6448",
                              fontWeight: 500,
                            }}
                          >
                            {moment(
                              props.activityData.activityTimeDisplay,
                            ).format(DateFormat.MomentDisplayDateTime24Format)}
                          </span>
                        </span>
                      )}
                      {props?.activityData?.airportCode && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            flex: 1,
                            justifyContent: "flex-end",
                          }}
                        >
                          <i
                            className="fas fa-plane"
                            style={{
                              color: "#FF6600",
                              fontSize: "12px",
                              flexShrink: 0,
                            }}
                          />
                          <span
                            style={{
                              fontSize: "0.78rem",
                              color: "#FF6600",
                              fontWeight: 600,
                            }}
                          >
                            {props.activityData.airportCode}
                          </span>
                        </span>
                      )}
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "9px",
                    }}
                  >
                    <i
                      className="fas fa-bus"
                      style={{
                        color: "#4f6ef7",
                        fontSize: "13px",
                        flexShrink: 0,
                      }}
                    ></i>
                    <span
                      style={{
                        fontSize: "0.82rem",
                        color: "#3d4a6b",
                        fontWeight: 500,
                      }}
                    >
                      {props?.activityData?.transportationCompany ||
                        props?.activityData?.transportationTypeName}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="form-group">
                <label>Current Hotel</label>
                {(() => {
                  const isDropOff =
                    props?.activityData?.tripTypeId === 2 ||
                    props?.activityData?.tripTypeId === 10 ||
                    props?.activityData?.tripTypeId === 16;
                  const hotelName = isDropOff
                    ? props?.activityData?.dropOffHotelName
                    : props?.activityData?.hotelName;
                  const hotelAddress = isDropOff
                    ? props?.activityData?.dropOffHotelAddress
                    : props?.activityData?.hotelAddress;
                  return (
                    <div
                      style={{
                        border: "1px solid #dee2e6",
                        borderRadius: "6px",
                        padding: "8px 12px",
                        background: "#f8f9fa",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <i
                        className="fas fa-hotel"
                        style={{
                          color: "#6c757d",
                          marginTop: "3px",
                          fontSize: "14px",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "0.85rem",
                            color: "#212529",
                          }}
                        >
                          {hotelName || (
                            <span style={{ color: "#adb5bd" }}>N/A</span>
                          )}
                        </div>
                        {hotelAddress && (
                          <div
                            style={{
                              fontSize: "0.78rem",
                              color: "#6c757d",
                              marginTop: "2px",
                            }}
                          >
                            <i
                              className="fas fa-map-marker-alt"
                              style={{ marginRight: "4px", fontSize: "11px" }}
                            ></i>
                            {hotelAddress}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #f0f4ff 0%, #fafbff 100%)",
                  border: "1px solid #d0d9f0",
                  borderRadius: "10px",
                  padding: "14px 16px",
                  marginTop: "4px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, #4f6ef7, #6c8fff)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="fas fa-exchange-alt"
                      style={{ color: "#fff", fontSize: "11px" }}
                    ></i>
                  </div>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: "0.85rem",
                      color: "#3d4a6b",
                    }}
                  >
                    Select New Hotel <span style={{ color: "#e53935" }}>*</span>
                  </span>
                </div>
                <SelectBox
                  dataSource={state.hotelDropdownDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Search and select hotel..."
                  //defaultValue={state.hotelId}
                  value={state.hotelId}
                  displayExpr="name"
                  valueExpr="id"
                  showClearButton={true}
                  searchEnabled={true}
                  disabled={state.isHotelTransferLoaded}
                  onValueChanged={async (e) => {
                    try {
                      let err = { ...state.errors };
                      err.hotel = "";
                      const selectedItem = state.hotelDropdownDataSource?.find(
                        (h) => h.id === e.value,
                      );
                      let hotelId = selectedItem?.id || 0;
                      let hotelCode = selectedItem?.code || "";
                      let hotelName = selectedItem?.name || "";
                      let hotelAddress = selectedItem?.address || "";
                      setState((prev) => ({
                        ...prev,
                        hotelId: hotelId,
                        hotelName: hotelName,
                        hotelAddress: hotelAddress,
                        hotelTransfer: "",
                        errors: err,
                      }));
                      if (hotelCode !== "") {
                        await getHotelTransfer(hotelCode);
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />
                {state.isHotelTransferLoaded && (
                  <i
                    className="fas fa-spinner fa-spin text-green"
                    style={{
                      float: "right",
                      marginTop: "-22px",
                      marginRight: "12px",
                    }}
                  />
                )}
                {state.hotelDropdownDataSource?.length === 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "8px",
                      padding: "8px 12px",
                      background: "#fff8e1",
                      borderRadius: "6px",
                      border: "1px solid #ffe082",
                    }}
                  >
                    <i
                      className="fas fa-exclamation-triangle"
                      style={{
                        color: "#f59f00",
                        fontSize: "13px",
                        flexShrink: 0,
                      }}
                    ></i>
                    <span
                      style={{
                        fontSize: "0.8rem",
                        color: "#7a5c00",
                        fontWeight: 500,
                      }}
                    >
                      Currently, no hotels are listed for this airport station.
                    </span>
                  </div>
                )}
                {state.hotelAddress && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "7px",
                      marginTop: "8px",
                      padding: "7px 10px",
                      background: "rgba(79,110,247,0.07)",
                      borderRadius: "6px",
                      border: "1px solid rgba(79,110,247,0.15)",
                    }}
                  >
                    <i
                      className="fas fa-map-marker-alt"
                      style={{
                        color: "#4f6ef7",
                        fontSize: "12px",
                        marginTop: "2px",
                        flexShrink: 0,
                      }}
                    ></i>
                    <span
                      style={{
                        fontSize: "0.78rem",
                        color: "#3d4a6b",
                        lineHeight: 1.4,
                      }}
                    >
                      {state.hotelAddress}
                    </span>
                  </div>
                )}
                {state.hotelTransfer && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "7px",
                      marginTop: "8px",
                      padding: "7px 10px",
                      background: "rgba(142,100,72,0.07)",
                      borderRadius: "6px",
                      border: "1px solid rgba(142,100,72,0.2)",
                    }}
                  >
                    <i
                      className="fas fa-shuttle-van"
                      style={{
                        color: "#8E6448",
                        fontSize: "12px",
                        marginTop: "2px",
                        flexShrink: 0,
                      }}
                    ></i>
                    <span
                      style={{
                        fontSize: "0.78rem",
                        color: "#5c3a1e",
                        lineHeight: 1.4,
                        fontWeight: 500,
                      }}
                    >
                      {state.hotelTransfer}
                    </span>
                  </div>
                )}
                {state.errors.hotel?.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      marginTop: "6px",
                    }}
                  >
                    <i
                      className="fas fa-exclamation-circle"
                      style={{ color: "#e53935", fontSize: "12px" }}
                    ></i>
                    <span style={{ color: "#e53935", fontSize: "0.78rem" }}>
                      {state.errors.hotel}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Submit"
            className="btn btn-primary"
            onClick={async (e) => {
              await handleOnChangeHotel(e);
            }}
            disabled={state.isSubmitted}
          >
            <i
              className={`fas fa-${state.isSubmitted ? "spinner fa-spin" : "check"}`}
            />
            &nbsp;&nbsp;Submit
          </button>
          <button
            type="button"
            title="Close"
            className="btn btn-secondary"
            onClick={() => {
              props.onClose();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
